import { render, staticRenderFns } from "./BottonmMenu3Edit.vue?vue&type=template&id=7eede6d2"
import script from "./BottonmMenu3Edit.vue?vue&type=script&lang=js"
export * from "./BottonmMenu3Edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports